import * as ClosetUtil from './ClosetUtil';
import { getUriParameterBoolean } from '../ltjsUtil';
export var traceEnabled = getUriParameterBoolean('debugTrace', false);
//
// A WeakMap used to track stack info from retain/release calls.
// Use of the WeakMap allows the entry to be removed when the
// ClosetObject key is garbage collected.
//
var retainReleaseTraceMap;
//
// Gets the trace information for a given ClosetObject.
//
function getTraceInfo(closetObject) {
    if (!retainReleaseTraceMap) {
        retainReleaseTraceMap = new WeakMap();
    }
    var traceInfo = retainReleaseTraceMap.get(closetObject);
    if (!traceInfo) {
        //
        // traceInfo contains arrays of stack traces, one for
        // retain and one for release.
        //
        traceInfo = {
            retain: [],
            release: [],
        };
        retainReleaseTraceMap.set(closetObject, traceInfo);
    }
    return traceInfo;
}
//
// Push the stack trace onto the trace info for closetObject.
//
export function traceRetain(closetObject) {
    var traceInfo = getTraceInfo(closetObject);
    var errorStack = new Error().stack;
    if (errorStack) {
        traceInfo.retain.push(errorStack);
    }
}
//
// Push the stack trace onto the trace info for closetObject.
//
export function traceRelease(closetObject) {
    var traceInfo = getTraceInfo(closetObject);
    var errorStack = new Error().stack;
    if (errorStack) {
        traceInfo.release.push(errorStack);
    }
}
//
// regex used for log output of the retain/release stack trace info.
// Normally, we want to show the line that called the retain or release.
// But when event listeners are attached, there is a private DispatchBridge that is
// retained, and showing that gives no useful info, so instead we show where the
// attachEventOnce/attachEvent/attachPropertyChangeEvent was called.
//
var RETAIN_TRACE_REGEX = [
    /EventDispatcher\.attachEventOnce.*\s.*/,
    /EventDispatcher.attachEvent.*\s.*/,
    /EventDispatcher.attachPropertyChangeEvent.*\s.*/,
    /ClosetObject.retain.*\s.*/,
];
var RELEASE_TRACE_REGEX = [/ClosetObject.release.*\s.*/];
function formatTrace(trace, regExpList) {
    if (!regExpList) {
        return trace;
    }
    //
    // regExpList is in priority order, so if we find a match return immediately,
    // otherwise keep searching.
    //
    for (var _i = 0, regExpList_1 = regExpList; _i < regExpList_1.length; _i++) {
        var regex = regExpList_1[_i];
        var matches = trace.match(regex);
        if (matches && matches.length > 0) {
            return matches[matches.length - 1];
        }
    }
    return trace;
}
export function logRetainReleaseTrace(closetObject) {
    var traceInfo = retainReleaseTraceMap ? retainReleaseTraceMap.get(closetObject) : undefined;
    if (!traceInfo) {
        console.log('There is no retain/release trace information for this object.');
        return;
    }
    var message = '\n**************************************************\n';
    message += "Type: ".concat(closetObject.getWrapperType(), "\n");
    message += "Address: ".concat(closetObject.getClosetAddress(), "\n");
    message += "Retain count: ".concat(closetObject.getRetainCount(), "\n");
    message += '\nRetain\n--------------------------------------------------\n';
    var retainTrace = traceInfo.retain;
    if (retainTrace) {
        for (var i = 0; i < retainTrace.length; i++) {
            message += "".concat(i, ")\t").concat(formatTrace(retainTrace[i], RETAIN_TRACE_REGEX), "\n");
        }
    }
    message += '\nRelease\n--------------------------------------------------\n';
    var releaseTrace = traceInfo.release;
    if (releaseTrace) {
        for (var i = 0; i < releaseTrace.length; i++) {
            message += "".concat(i, ")\t").concat(formatTrace(releaseTrace[i], RELEASE_TRACE_REGEX), "\n");
        }
    }
    message += '\n**************************************************\n';
    console.log(message);
}
export function log() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (traceEnabled) {
        console.log.apply(console, ['TRACE'].concat(Array.from(args)));
    }
}
var makeConverter = function (ArrayType) {
    var typedArray = new ArrayType(1);
    return function (value) {
        typedArray[0] = value;
        return typedArray[0];
    };
};
export var traceConversions = {
    convertInt: makeConverter(Int32Array),
    convertUnsigned: makeConverter(Uint32Array),
    convertFloat: makeConverter(Float32Array),
    convertDouble: makeConverter(Float64Array),
    convertEnum: makeConverter(Int32Array),
    convertBool: function (arg) { return !!arg; },
    convertPoint: function (arg) {
        if (!arg)
            return [NaN, NaN];
        return traceConversions.convertArray(arg, traceConversions.convertFloat);
    },
    convertRectangle: function (arg) {
        if (!arg)
            return [NaN, NaN, NaN, NaN];
        return traceConversions.convertArray(arg, traceConversions.convertFloat);
    },
    convertString: function (arg) {
        return typeof arg === 'string' ? arg : null;
    },
    convertModel: function (arg) {
        return ClosetUtil.getAddress(arg) || null;
    },
    convertArray: function (arg, converter) {
        return Array.isArray(arg) ? arg.map(converter) : null;
    },
};
